export default "__VITE_ASSET__bimCAq_G__"